import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Projects from "@/pages/Projects";
import ProjectWizard from "@/pages/ProjectWizard";
import Products from "@/pages/Products";
import Suppliers from "@/pages/Suppliers";
import SupplierOffers from "@/pages/SupplierOffers";
import Stock from "@/pages/Stock";
import Settings from "@/pages/Settings";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) return (
    <div className="min-h-screen grid place-items-center text-sm text-muted-foreground">Yükleniyor...</div>
  );
  if (!user || !user.email) return <Navigate to="/login" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Protected><Layout /></Protected>}>
            <Route index element={<Dashboard />} />
            <Route path="projects" element={<Projects />} />
            <Route path="projects/new" element={<ProjectWizard />} />
            <Route path="projects/:id" element={<ProjectWizard />} />
            <Route path="products" element={<Products />} />
            <Route path="suppliers" element={<Suppliers />} />
            <Route path="offers" element={<SupplierOffers />} />
            <Route path="stock" element={<Stock />} />
            <Route path="settings" element={<Settings />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
